import React from "react";
import useRouter from "../../hooks/router";

const DARK_BG = "#111e27";
const NAV_BG = "#1a3a4a";
const CARD_BG = "#1e3547";
const TEXT_MAIN = "#e8f0f4";
const TEXT_MUTED = "#8fafc4";
const BORDER = "rgba(255,255,255,0.12)";
const ACCENT = "#00c9a7";

const Contact = () => {
  const { handleNavigation } = useRouter();

  return (
    <div style={{ background: DARK_BG, minHeight: "100vh" }} className="font-outfit">
      <nav style={{ background: NAV_BG, borderBottom: `1px solid ${BORDER}` }} className="w-full px-6 py-4 flex items-center justify-between shadow-md">
        <img src="/logo.svg" alt="RefAlign" className="h-9 cursor-pointer" onClick={() => handleNavigation("/")} />
        <button
          onClick={() => handleNavigation("/pricing")}
          style={{ color: TEXT_MAIN, border: `1px solid ${BORDER}` }}
          className="px-4 py-2 rounded-lg text-sm hover:bg-white hover:bg-opacity-5 transition-all"
        >
          Pricing
        </button>
      </nav>

      <main className="px-4 sm:px-6 py-16">
        <div className="max-w-3xl mx-auto">
          <div style={{ background: CARD_BG, border: `1px solid ${BORDER}` }} className="rounded-3xl p-6 sm:p-8 shadow-2xl">
            <div className="text-center mb-8">
              <div style={{ background: "rgba(0,201,167,0.12)", color: ACCENT, border: "1px solid rgba(0,201,167,0.25)" }} className="inline-block px-4 py-1.5 rounded-full text-sm font-medium mb-4">
                Talk to us
              </div>
              <h1 style={{ color: TEXT_MAIN }} className="text-3xl sm:text-4xl font-bold mb-3">Book a demo or ask a question</h1>
              <p style={{ color: TEXT_MUTED }} className="text-base sm:text-lg max-w-2xl mx-auto">
                If you’re a referee, club, or assigner, send your details and we’ll get back to you.
              </p>
            </div>

            <form className="grid grid-cols-1 gap-4">
              {[
                ["Name", "Your name"],
                ["Email", "you@example.com"],
                ["Role", "Referee, assigner, club admin..."],
              ].map(([label, placeholder]) => (
                <div key={label}>
                  <label style={{ color: TEXT_MUTED }} className="block text-xs font-medium mb-1.5">{label}</label>
                  <input
                    placeholder={placeholder}
                    className="w-full px-4 py-3 rounded-xl text-sm outline-none"
                    style={{ background: "rgba(255,255,255,0.05)", color: TEXT_MAIN, border: `1px solid ${BORDER}` }}
                  />
                </div>
              ))}
              <div>
                <label style={{ color: TEXT_MUTED }} className="block text-xs font-medium mb-1.5">Message</label>
                <textarea
                  rows="5"
                  placeholder="Tell us what you’re looking for"
                  className="w-full px-4 py-3 rounded-xl text-sm outline-none"
                  style={{ background: "rgba(255,255,255,0.05)", color: TEXT_MAIN, border: `1px solid ${BORDER}` }}
                />
              </div>
              <button
                type="button"
                style={{ background: ACCENT, color: "#0d2230" }}
                className="w-full py-3 rounded-xl text-sm font-bold hover:opacity-90 transition-all shadow-lg mt-2"
              >
                Send Request
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Contact;
